import {} from "../half-edge/index.js";
import {} from "../mod/index.js";
import { createNet } from "../net/createNet.js";
import { findHalfEdgeEntryOrFail } from "../net/findHalfEdgeEntryOrFail.js";
import { findHalfEdgePortOrFail } from "../net/findHalfEdgePortOrFail.js";
import {} from "../net/index.js";
import { moveConnectedComponent } from "../net/moveConnectedComponent.js";
import { runNet } from "./runNet.js";
export function runHalfEdge(mod, net, halfEdge) {
    const component = createNet();
    const halfEdgeEntry = findHalfEdgeEntryOrFail(net, halfEdge);
    const otherPort = findHalfEdgePortOrFail(net, halfEdgeEntry.otherHalfEdge);
    moveConnectedComponent(net, component, otherPort.node);
    runNet(mod, component);
    const resultPort = findHalfEdgePortOrFail(component, halfEdgeEntry.otherHalfEdge);
    moveConnectedComponent(component, net, resultPort.node);
}
//# sourceMappingURL=runHalfEdge.js.map